import { DATEFORMAT, CvDateFormatter } from '@cv-invision/cv.component-library.ux';

/**
 * Defines the columns
 * And any action against the columns
 */
export class NexsysOrderColumnsModel {
	private _columns: Array<any>;
	constructor(dateService:CvDateFormatter) {
		this._columns = [
			{
				headerName: 'Class Order ID',
				field: 'id',
				width: 100
			},
			{
				headerName: 'Product',
				width: 150,
				cellRenderer: 'customActionShowProductModalCellComponent'
			},
			{
				headerName: 'Origin',
				field: 'origin',
				width: 75,
				resizable: false
			},
			{
				headerName: 'Provider',
				field: 'provider',
				width: 70
			},
			{
				headerName: 'Provider ID',
				field: 'providerId',
				width: 70
			},
			{
				headerName: 'Acuity ID',
				field: 'acuityId',
				width: 115
			},
			{
				headerName: 'Acuity Trans. Status',
				field: 'acuityResponseStatus',
				width: 95
			},
			{
				headerName: 'AppScope File #',
				field: 'appscopeAppraisalFileNumber',
				width: 70
			},
			{
				headerName: 'AppScope Trans. Status',
				field: 'appscopeResponseStatus',
				width: 95
			},
			{
				headerName: 'Addendum',
				field: 'addendumInfo',
				width: 70
			},
			{
				headerName: 'Associated Id',
				field: 'associatedProviderId',
				width: 70
			},
			{
				headerName: 'Associated Ad Id',
				field: 'associatedAddendumProviderId',
				width: 70
			},
			{
				headerName: 'Received (Local)',
				field: 'created',
				width: 160,
				valueFormatter: params => dateService.format(DATEFORMAT.EMPTY, params.data.created)
			},
			{
				headerName: 'Logs',
				width: 150,
				cellRenderer: 'customActionNexsysOrdersCellComponent'
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}
